import { getSearchItemBadgeLabel } from '@/modules/search/searchGrid/utils/searchResultsHelpers';

const MAX_LABELS = 3;

export function buildSearchTabTitle(searchItems?: any[] | null, search?: string): string {
  if (searchItems && searchItems.length > 0) {
    const labels = searchItems
      .slice(0, MAX_LABELS)
      .map(item => getSearchItemBadgeLabel(item).label)
      .filter(Boolean);
    const extra = searchItems.length > MAX_LABELS ? ` +${searchItems.length - MAX_LABELS}` : '';
    if (labels.length > 0) {
      return `${labels.join(', ')}${extra}`;
    }
  }

  const raw = (search ?? '').replace(/^\?/, '');
  const params = new URLSearchParams(raw);
  const idents = params.get('idents');
  if (!idents || idents === 'ALL') {
    return 'All results';
  }

  const parts = idents.split('-').filter(Boolean);
  if (parts.length === 0) return 'All results';
  if (parts.length <= MAX_LABELS) return parts.join(', ');
  return `${parts.slice(0, MAX_LABELS).join(', ')} +${parts.length - MAX_LABELS}`;
}
